module.exports = __webpack_public_path__ + "static/media/user.aab414f7.jpg";